import Text from '#components/a/Text'
import AddTaetigkeitButton from '#components/m/Ausbildungsnachweis/AddTaetigkeitButton'
import FileViewer from '#components/m/Ausbildungsnachweis/FileViewer'
import NachweisDetailAzubiInstructions from '#components/m/Ausbildungsnachweis/NachweisDetailAzubiInstructions'
import TaetigkeitenListe from '#components/m/Ausbildungsnachweis/TaetigkeitenListe'
import Comment from '#components/m/Comment'
import CommentInput from '#components/m/CommentInput'
import Tabz from '#components/m/Tabz'
import {isDraftOrRejected, isSubmitted, isSubmittedOrConfirmed, statusTypes} from 'ag-common/tools/fileStatus'
import {getMaxQualificationsCountForNachweisTyp} from 'ag-common/tools/nachweisQualifikationen'
import {
  getTabsForNachweisTypeLongNames,
  isTypWithQualification,
  nachweisTypes,
} from 'ag-common/tools/nachweisTypConstants'
import {sortTaetigkeitenAscending} from 'ag-common/tools/sortTaetigkeiten'
import i18n from 'i18next'
import PropTypes from 'prop-types'
import React from 'react'

export class NachweisDetailTaetigkeiten extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      taetigkeiten: props.nachweis.taetigkeiten,
    }
  }

  componentDidMount() {
    this.forceUpdateTimeout = window.setTimeout(() => this.forceUpdate(), 1000)
  }

  componentDidUpdate(prevProps) {
    if (prevProps.nachweis.taetigkeiten !== this.props.nachweis.taetigkeiten) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        taetigkeiten: this.props.nachweis.taetigkeiten,
      })
    }
  }

  componentWillUnmount() {
    window.clearTimeout(this.forceUpdateTimeout)
  }

  getTaetigkeiten = (gruppe, isDisabled) => {
    const {handleDeleteTaetigkeit, handleUpdateTaetigkeit, nachweisTyp, userId} = this.props
    const {taetigkeiten} = this.state
    const maxQualificationsPerGroup = getMaxQualificationsCountForNachweisTyp(nachweisTyp)
    const withWorktime = this.showWorktime()
    const withQualification = this.showQualification()
    const canEditQualification = this.canEditQualification()
    const taetigkeitenForGroup = sortTaetigkeitenAscending(taetigkeiten.filter(nt => nt.gruppe === gruppe.index))
    return (
      <TaetigkeitenListe
        key={gruppe.index}
        maxQualificationsPerGroup={maxQualificationsPerGroup}
        taetigkeiten={taetigkeitenForGroup}
        isDisabled={isDisabled}
        userId={userId}
        handleDeleteTaetigkeit={handleDeleteTaetigkeit}
        handleChangeTaetigkeit={this.handleChangeTaetigkeit}
        handleUpdateTaetigkeit={handleUpdateTaetigkeit}
        withQualification={withQualification}
        withWorktime={withWorktime}
        canEditQualification={canEditQualification}
      />
    )
  }

  canEditQualification = () => {
    const {permissions, nachweis} = this.props
    if (permissions.nachweis.edit) {
      return isDraftOrRejected(nachweis.status)
    }
    if (permissions.nachweis.verify) {
      return isSubmitted(nachweis.status)
    }
    return false
  }

  showQualification = () => {
    const {nachweisTyp} = this.props
    return isTypWithQualification(nachweisTyp)
  }

  showWorktime = () => {
    const {nachweisTyp} = this.props

    return nachweisTyp !== nachweisTypes.MONTHLY
  }

  getTabTitlesForGroup = gruppe => {
    const hasAttachment = this.attachmentsExistInGroup(gruppe)
    return (
      <>
        <div className="tabTitle">{gruppe.title}</div>
        <div className={hasAttachment ? 'withAttachment' : null} />
      </>
    )
  }

  attachmentsExistInGroup = gruppe => {
    const {nachweis} = this.props
    if (!nachweis || !nachweis.anhaenge) {
      return false
    }
    const filtered = nachweis.anhaenge.filter(file => file.gruppe === gruppe.index)
    if (filtered.length > 0) {
      return true
    }
    return false
  }

  getTabContentForGroup = gruppe => {
    const {
      nachweis,
      nachweisTyp,
      handleAddTaetigkeit,
      handleUploadFile,
      isNewNachweis,
      disableAddTaetigkeit,
      permissions,
    } = this.props
    const isDisabled = !(permissions.nachweis.edit && isDraftOrRejected(nachweis.status))

    return (
      <>
        {!isDisabled && (
          <div className="nachweisdetail__taetigkeiten__header">
            <AddTaetigkeitButton
              gruppe={gruppe}
              nachweis={nachweis}
              nachweisTyp={nachweisTyp}
              handleAddTaetigkeit={handleAddTaetigkeit}
              handleUploadFile={handleUploadFile}
              isNewNachweis={isNewNachweis}
              disableAddTaetigkeit={disableAddTaetigkeit}
            />
          </div>
        )}

        <div className="nachweisdetail__taetigkeiten__wrapper">{this.getTaetigkeiten(gruppe, isDisabled)}</div>
        {(permissions.nachweis.edit || isSubmittedOrConfirmed(nachweis.status)) &&
          this.renderFileLinkButton(gruppe, nachweis.anhaenge)}
      </>
    )
  }

  handleAttachmentDelete = blobId => e => {
    e.stopPropagation()
    this.props.handleDeleteFile(blobId)
  }

  renderFileLinkButton = (gruppe, fileList = []) => {
    const {nachweis} = this.props
    const filtered = fileList.filter(file => file.gruppe === gruppe.index)

    const buttons = filtered.map(file => (
      <FileViewer
        key={file.blobId}
        isReadOnly={!isDraftOrRejected(nachweis.status)}
        file={file}
        handleAttachmentDelete={this.handleAttachmentDelete}
        userId={nachweis.userId}
      />
    ))
    if (buttons.length > 0) {
      return (
        <div className="attachment__container" key={gruppe.index}>
          {buttons}
        </div>
      )
    }
    return null
  }

  renderComments = () => {
    const {nachweis, permissions} = this.props
    if (nachweis.kommentare !== undefined) {
      nachweis.kommentare.sort((a, b) => new Date(a.timeStamp) - new Date(b.timeStamp))

      if (permissions.nachweis.verify && nachweis.status === statusTypes.submitted) {
        return nachweis.kommentare.map(comment => (
          <Comment
            key={comment.timeStamp}
            authorId={comment.authorId}
            timeStamp={comment.timeStamp}
            authorName={comment.authorName}>
            <Text modifier="shy" text={`„${comment.text}”`} />
          </Comment>
        ))
      }

      var messages = []
      if (nachweis.status === statusTypes.rejected || nachweis.status === statusTypes.submitted) {
        messages = nachweis.kommentare
          .filter(comment => comment.isfromFreigabe === false)
          .map(comment => (
            <Comment
              key={comment.timeStamp}
              authorId={comment.authorId}
              timeStamp={comment.timeStamp}
              authorName={comment.authorName}>
              <Text modifier="shy" text={`„${comment.text}”`} />
            </Comment>
          ))
      } else if (nachweis.status === statusTypes.confirmed) {
        messages = nachweis.kommentare
          .filter(comment => comment.isfromFreigabe === true)
          .map(comment => (
            <Comment
              key={comment.timeStamp}
              authorId={comment.authorId}
              timeStamp={comment.timeStamp}
              authorName={comment.authorName}>
              <Text modifier="shy" text={`„${comment.text}”`} />
            </Comment>
          ))
      }
      if (messages.length < 1) {
        return null
      }
      return messages
    }
    return null
  }

  renderCommentSection = () => {
    const {handleFreigeben, handleAblehnen, nachweis, permissions} = this.props

    return (
      <div className="nachweisdetail__taetigkeiten__sidebar">
        {this.renderComments()}
        {permissions.nachweis.verify && nachweis.status === statusTypes.submitted ? (
          <CommentInput
            id="comment_input"
            confirmCallback={commentText => handleFreigeben(commentText)}
            rejectCallback={commentText => handleAblehnen(commentText)}
          />
        ) : null}
      </div>
    )
  }

  handleChangeTaetigkeit = taetigkeit => {
    const {handleChangeTaetigkeit} = this.props
    if (handleChangeTaetigkeit) {
      handleChangeTaetigkeit(taetigkeit)
    }
    /*this.setState(prevState => {
      //Das aus den Props nehmen und Props von außen updaten. 
      const taetigkeiten = prevState.taetigkeiten.map(t => (t.id === taetigkeit.id ? taetigkeit : t))
      return {
        taetigkeiten,
      }
    })*/
  }

  render() {
    const {nachweis, nachweisTyp} = this.props
    const tabHeaders = getTabsForNachweisTypeLongNames(nachweisTyp).map(({index, titleKey}) => ({
      index,
      title: i18n.t(titleKey) || '',
    }))
    const isWeeklyOrMonthly = nachweisTyp === nachweisTypes.WEEKLY || nachweisTyp === nachweisTypes.MONTHLY

    const tabs = tabHeaders.map(group => [this.getTabTitlesForGroup(group), this.getTabContentForGroup(group)])
    return (
      <div className="nachweisdetail__taetigkeiten">
        <div className="row">
          <div className="nachweisdetail__taetigkeiten__content">
            {isWeeklyOrMonthly ? (
              tabs.map((tab, index) => {
                return (
                  <div key={index}>
                    <div className="box" key={tab[0]}>
                      <div className="nachweisdetail__taetigkeiten__content__title">
                        <div className="nachweisdetail__taetigkeiten__content__title__text">{tab[0]}</div>
                        <div className="nachweisdetail__taetigkeiten__content__title__yellowbar"></div>
                      </div>
                      <div>{tab[1]}</div>
                    </div>
                  </div>
                )
              })
            ) : (
              <Tabz tabz={tabs} tabMinWidth={'true'} tabWidth={'true'} />
            )}
          </div>
          <NachweisDetailAzubiInstructions nachweisStatus={nachweis.status} />
          {this.renderCommentSection()}
        </div>
      </div>
    )
  }
}

NachweisDetailTaetigkeiten.propTypes = {
  userId: PropTypes.number,
  nachweis: PropTypes.object,
  handleAddTaetigkeit: PropTypes.func,
  handleDeleteTaetigkeit: PropTypes.func,
  handleUpdateTaetigkeit: PropTypes.func,
  handleChangeTaetigkeit: PropTypes.func,
  handleUploadFile: PropTypes.func,
  handleDeleteFile: PropTypes.func,
  isNewNachweis: PropTypes.bool,
  nachweisTyp: PropTypes.string,
  disableAddTaetigkeit: PropTypes.bool,
  permissions: PropTypes.object,
  handleFreigeben: PropTypes.func,
  handleAblehnen: PropTypes.func,
}

export default NachweisDetailTaetigkeiten
